import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { InfrastructureSlide } from './MultiCarousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { fetchPublicInfraCategories, fetchPublicInfraItems } from '../lib/api';

// Static fallback images (used when API has no data yet)
const Science = [
    `${require('../images/infrastructur/infrastructur1.jpg')}`,
    `${require('../images/infrastructur/infrastructur2.jpg')}`,
    `${require('../images/infrastructur/infrastructur3.jpg')}`,
    `${require('../images/infrastructur/infrastructur4.jpg')}`,
]
const Computer = [
    `${require('../images/infrastructur/infrastructur5.jpg')}`,
    `${require('../images/infrastructur/infrastructur6.jpg')}`,
]
const LibraryImg = [
    `${require('../images/infrastructur/infrastructur7.jpg')}`,
    `${require('../images/infrastructur/infrastructur8.jpg')}`,
]
const multyImg = [
    `${require('../images/infrastructur/infrastructur9.jpg')}`,
    `${require('../images/infrastructur/infrastructur8.jpg')}`,
    `${require('../images/infrastructur/infrastructur10.jpg')}`,
]
const room = [
    `${require('../images/infrastructur/infrastructur10.jpg')}`,
    `${require('../images/infrastructur/infrastructur12.jpg')}`,
    `${require('../images/infrastructur/infrastructur13.jpg')}`,
]
const Assembly = [
    `${require('../images/infrastructur/infrastructur14.jpg')}`,
    `${require('../images/infrastructur/infrastructur17.jpg')}`,
]
const Pantryimg = [
    `${require('../images/infrastructur/pantry1.jpg')}`,
]
const Creative = [
    `${require('../images/infrastructur/infrastructur9.jpg')}`,
    `${require('../images/infrastructur/infrastructur10.jpg')}`,
    `${require('../images/infrastructur/infrastructur11.jpg')}`,
    `${require('../images/infrastructur/infrastructur12.jpg')}`,
]
const InfirmaryImg = [
    `${require('../images/infrastructur/infrastructur17.jpg')}`,
    `${require('../images/infrastructur/infrastructur14.jpg')}`,
    `${require('../images/infrastructur/infrastructur13.jpg')}`,
]

// Static descriptions (original text, shown regardless of API)
const DESCRIPTIONS = {
    'Science Laboratories': 'The laboratories are well equipped to support the learning of science to inculcate scientific temper in students. Experimentation and investigative skills are taught and encouraged under the supervision and guidance of experienced teachers. The school ensures high standards of safety in its laboratories.',
    'Computer Laboratory': 'To keep the students abreast with the Information Technology, the computer laboratory has been set up. Adequate number of computer hardware are installed in the Computer laboratory. The lab has facility of WIFI zone, powered by LAN connectivity.',
    'Library': 'The school Library houses a good collection of books, magazines, periodicals and audio-visual materials. Such facility caters to the needs of the children of varying age groups and makes them aware of more information over and above the classroom learning. The ambience has been so created which makes the children feel comfortable and makes their reading enjoyable.',
    'Multi-purpose area': 'The multi-purpose area provides space for several activities and cultural programmes, at times. This area is used for indoor games during monsoon. Usually the dance classes are held there.',
    'AV room': 'Interactive learning sessions are conducted in the Audio-Visual room, equipped with LCD Projector and a screen. Learning through digital media is performed using google chrome. The school conducts meetings and holds training sessions in this AV room for the teachers.',
    'Assembly Area': 'The school has an open area in the center portion of the building with a stage at one end. The day starts with the morning assembly in this area. At morning assembly, the students gather in the large and spacious assembly area where they conduct the morning\'s proceedings under the guidance of the teachers.',
    'Pantry': 'In keeping with the proverb "A healthy mind in a healthy body", the school aims at providing wholesome, nutritious vegetarian meal to the students. Such food is prepared in a strictly hygienically maintained pantry by a team of skilled and experienced kitchen staff who serves the children with love and care.',
    'Creative Corner': 'The Art, Craft and Music classes are held for the students in this Creative Corner. They have low seating arrangement in this room. The creative works of the students are displayed on the four walls of the room, making the room look appealing.',
    'Infirmary': 'The school has an infirmary with a bed and first-aid kit. Students who suddenly fall ill or are accidentally injured seek refuge there and are given first-aid.',
}

// Static fallback images per category name
const STATIC_IMAGES = {
    'Science Laboratories': Science,
    'Computer Laboratory': Computer,
    'Library': LibraryImg,
    'Multi-purpose area': multyImg,
    'AV room': room,
    'Assembly Area': Assembly,
    'Pantry': Pantryimg,
    'Creative Corner': Creative,
    'Infirmary': InfirmaryImg,
}

const STATIC_CAT_NAMES = Object.keys(STATIC_IMAGES)

const Infrastructure = () => {
    const navigate = useNavigate()
    const [srishtiClass, setSrishtiClass] = useState(STATIC_CAT_NAMES[0])
    const [catNames, setCatNames]         = useState(STATIC_CAT_NAMES)
    const [apiImages, setApiImages]       = useState({}) // { catName: [url, ...] }

    useEffect(() => { AOS.init({ duration: 1500 }); })

    useEffect(() => {
        const load = async () => {
            try {
                const [catRes, itemRes] = await Promise.all([
                    fetchPublicInfraCategories(true),
                    fetchPublicInfraItems({ isActive: true }),
                ])
                const cats  = Array.isArray(catRes.data)  ? catRes.data  : []
                const items = Array.isArray(itemRes.data) ? itemRes.data : []

                // Group images by category id
                const byId = {}
                items.forEach(item => {
                    if (!item.mediaUrl) return
                    if (!byId[item.categoryId]) byId[item.categoryId] = []
                    byId[item.categoryId].push(item.mediaUrl)
                })

                // Map category name -> images
                const byName = {}
                cats.forEach(cat => { byName[cat.name] = byId[cat.id] || [] })

                if (cats.length > 0) {
                    const names = cats.map(c => c.name)
                    setCatNames(names)
                    setSrishtiClass(names[0])
                }
                setApiImages(byName)
            } catch {
                // Keep static fallback on error
            }
        }
        load()
    }, [])

    // Use API images if available, otherwise static fallback
    const getImages = (name) => {
        const api = apiImages[name]
        if (api && api.length > 0) return api
        return STATIC_IMAGES[name] || []
    }

    return (
        <div>
            <div data-aos="zoom-in-up" class='d-grid align-items-center justify-content-center p-5'
                style={{ backgroundImage: `url(${require("../images/about/top.png")})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                <div>
                    <p class='display-3 fw-bold'>Infrastructure</p>
                    <p class='fw-semibold'>
                        <span onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>Home</span>
                        <span>|</span>
                        <span onClick={() => navigate("/infrastructure")} style={{ cursor: 'pointer' }}>Infrastructure</span>
                    </p>
                </div>
            </div>

            <div style={{ marginLeft: '50px' }}>
                <div class='infraBtnDiv'>
                    {catNames.map(name => (
                        <div key={name} class='text-nowrap infraBtn'
                            style={srishtiClass === name ? { borderBottom: '5px solid #F37335' } : { borderBottom: '.5px solid' }}
                            onClick={() => setSrishtiClass(name)}>
                            {name}
                        </div>
                    ))}
                </div>

                {/* Content — same two-column layout as original */}
                <div class='row'>
                    <div class='col-lg-6 col-12'>
                        <div class='text-start m-auto mt-5'>
                            <div class='col-11 m-auto'>
                                <p class="fw-bold fs-4" style={{ color: '#F37335' }}>{srishtiClass}</p>
                                {DESCRIPTIONS[srishtiClass] && (
                                    <p style={{ color: 'gray' }}>{DESCRIPTIONS[srishtiClass]}</p>
                                )}
                                <button class='btn my-3 fs-5' id='button'
                                    onClick={() => navigate('/admission')}
                                    style={{ width: 'fit-content' }}>
                                    <span><i class="bi bi-arrow-right-circle-fill"></i></span>
                                    <span class=' mx-2 m-0'>Admissions</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class='col-lg-6 col-12 p-3'>
                        <InfrastructureSlide images={getImages(srishtiClass)} />
                    </div>
                </div>

                <br /><br />
            </div>

            <div style={{ background: '#155799' }}>
                <br /><br />
            </div>
        </div>
    )
}

export default Infrastructure
